/**
 * 403 Forbidden Page
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';

export const ForbiddenPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div data-testid="forbidden-page" style={{
      display: 'flex', flexDirection: 'column', justifyContent: 'center',
      alignItems: 'center', minHeight: '100vh', textAlign: 'center',
      fontFamily: "'Hanken Grotesk', sans-serif",
    }}>
      <p style={{ fontSize: '6rem', fontWeight: 700, margin: '0 0 8px', color: 'var(--text-main, #1A3A52)' }}>403</p>
      <p style={{ fontSize: '1.5rem', fontWeight: 700, margin: '0 0 8px', color: 'var(--text-main, #1A3A52)' }}>Access Denied</p>
      <p style={{ fontSize: '1rem', color: 'var(--muted, #888)', marginBottom: '2rem' }}>
        You don't have permission to access this resource.
      </p>
      <button
        onClick={() => navigate('/')}
        data-testid="forbidden-home-btn"
        style={{
          padding: '10px 24px', borderRadius: '8px', border: 'none',
          background: 'var(--color-teal, #2B9BA5)', color: '#fff',
          fontSize: '14px', fontWeight: 600, cursor: 'pointer',
          fontFamily: "'Hanken Grotesk', sans-serif",
        }}
      >
        Go to Home
      </button>
    </div>
  );
};
